"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../../App");
var paginatorList_1 = require("../paginatorList");
var editablelist_1 = require("../editablelist");
var utils_1 = require("../../../utils");
var columns_1 = require("../columns");
var api_1 = require("../../../api");
var contexts_1 = require("../../../interfaces/contexts");
var causalityDialog_1 = require("../../causalities/causalityDialog");
var CausalityTable = (function (_super) {
    __extends(CausalityTable, _super);
    function CausalityTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.CausalityClickHandler = function (event, causality_id) {
            (0, utils_1.preventDefault)(event);
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                api_1.api.projects.id(context.project).causalities.id(causality_id).get().then(function (causality) {
                    _this.props.dialogState.openDialog(causality);
                });
            }
            else {
                throw new Error("Cannot open CausalityDialog outside of project context");
            }
        };
        _this.refetchTable = function (event) {
            var params = window.location.search;
            if (event) {
                (0, utils_1.preventDefault)(event);
                var url = new URL(event.currentTarget.href);
                var search = new URLSearchParams(url.search);
                params = "?" + search.toString();
            }
            window.history.pushState(null, null, window.location.pathname + params);
            var stateFragment = _this.getStateFragment();
            stateFragment.fetchData.bind(stateFragment)(params);
            stateFragment.filter.fetchData.bind(stateFragment.filter)();
        };
        return _this;
    }
    CausalityTable.prototype.getStateFragment = function () {
        if (this.props.is_cause)
            return App_1.store.causalitylist.causes;
        else
            return App_1.store.causalitylist.effects;
    };
    CausalityTable.prototype.componentDidMount = function () {
        var _this = this;
        var location = window.location.search;
        var params = new URLSearchParams(location);
        var causality_id = parseInt(params.get("causality_id"));
        if (causality_id && !isNaN(causality_id)) {
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                api_1.api.projects.id(context.project).causalities.id(causality_id).get().then(function (causality) {
                    _this.props.dialogState.openDialog(causality);
                });
            }
        }
    };
    CausalityTable.prototype.performBulkUpdate = function (selected, values) {
        values["causalities"] = selected;
        return this.getStateFragment().updateRows.bind(this.getStateFragment())(values);
    };
    CausalityTable.prototype.performRowUpdate = function (data) {
        return this.getStateFragment()
            .updateRows.bind(this.getStateFragment())(data)
            .then(function (response) {
            notification(response.message);
        });
    };
    CausalityTable.prototype.detachRisk = function (risk, causality_id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, App_1.store.causalitylist.checkDetachRisk(risk, causality_id).then(function (page) {
                        return App_1.store.causalitylist.removeRisk(risk, causality_id).then(function () {
                            _this.refetchTable();
                            return Promise.resolve(true);
                        });
                    }, function (error) {
                        var reason = JSON.parse(error.responseText);
                        if (reason.confirm) {
                            return optionDialog(reason.confirm, [{
                                    text: gettext("Retain confidentiality"),
                                    "class": "btn btn-primary",
                                    click: function () { return App_1.store.causalitylist.removeRisk(risk, causality_id, true).then(function () {
                                        _this.refetchTable();
                                        return Promise.resolve(true);
                                    }); }
                                }, {
                                    text: gettext("Make public"),
                                    "class": "btn btn-secondary",
                                    click: function () { return App_1.store.causalitylist.removeRisk(risk, causality_id, false).then(function () {
                                        _this.refetchTable();
                                        return Promise.resolve(true);
                                    }); }
                                }], null, null, 500);
                        }
                        else {
                            return Promise.resolve(true);
                        }
                    })];
            });
        });
    };
    CausalityTable.prototype.detachControl = function (control, causality_id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, App_1.store.causalitylist.checkDetachControl(control, causality_id).then(function (page) {
                        return App_1.store.causalitylist.removeControl(control, causality_id).then(function () {
                            _this.refetchTable();
                            return Promise.resolve(true);
                        });
                    }, function (error) {
                        var reason = JSON.parse(error.responseText);
                        if (reason.confirm) {
                            return optionDialog(reason.confirm, [{
                                    text: gettext("Retain confidentiality"),
                                    "class": "btn btn-primary",
                                    click: function () { return App_1.store.causalitylist.removeControl(control, causality_id, true).then(function () {
                                        _this.refetchTable();
                                        return Promise.resolve(true);
                                    }); }
                                }, {
                                    text: gettext("Make public"),
                                    "class": "btn btn-secondary",
                                    click: function () { return App_1.store.causalitylist.removeControl(control, causality_id, false).then(function () {
                                        _this.refetchTable();
                                        return Promise.resolve(true);
                                    }); }
                                }], null, null, 500);
                        }
                        else {
                            return Promise.resolve(true);
                        }
                    })];
            });
        });
    };
    CausalityTable.prototype.render = function () {
        var data = this.getStateFragment().data;
        var relationsProps = {};
        relationsProps[columns_1.CausalityColumnIds.RISK_RELATIONS] = {
            fetchSearchResults: App_1.store.causalitylist.fetchAttachableRiskSuggestions,
            fetchRowItems: App_1.store.causalitylist.fetchRowRiskRelations,
            attach: App_1.store.causalitylist.attachRisk,
            detach: this.detachRisk.bind(this),
        };
        relationsProps[columns_1.CausalityColumnIds.CONTROL_RELATIONS] = {
            fetchSearchResults: App_1.store.causalitylist.fetchAttachableControlSuggestions,
            fetchRowItems: App_1.store.causalitylist.fetchRowControlRelations,
            attach: App_1.store.causalitylist.attachControl,
            detach: this.detachControl.bind(this),
        };
        var relation = this.props.is_cause ? App_1.store.causalitylist.causeBulkMenu : App_1.store.causalitylist.effectBulkMenu;
        var dialogClass = this.props.is_cause ? "CausalityTable__CauseDialog" : "CausalityTable__EffectDialog";
        return (React.createElement("div", { className: "CausalityTable" },
            React.createElement(editablelist_1.EditableList, { columns: data.columns, headers: data.headers, rows: data.rows, rowClickHandler: this.CausalityClickHandler, headerSortClickHandler: this.refetchTable.bind(this), performRowUpdate: this.performRowUpdate.bind(this), refetchTable: this.refetchTable.bind(this), relationProps: relationsProps, allowBulkEditing: true, performBulkUpdate: this.performBulkUpdate.bind(this), bulkEditFields: data.bulk_edit_fields, bulkMenuState: relation.data, updateBulkMenuState: relation.getFetchDataMethod() }),
            React.createElement("div", { className: "CausalityTable__Footer mt-1" },
                React.createElement(paginatorList_1.default, { paginator: this.getStateFragment().data.paginator, click: this.refetchTable })),
            React.createElement("div", { className: dialogClass },
                React.createElement(causalityDialog_1.CausalityDialog, { isCause: this.props.dialogState.isCause, isOpen: this.props.dialogState.isOpen, causality: this.props.dialogState.causality, causeSearchResults: this.props.dialogState.causeSearchResults, effectSearchResults: this.props.dialogState.effectSearchResults, affectedRisks: this.props.dialogState.affectedRisks, affectedControls: this.props.dialogState.affectedControls, isLoadingRisks: this.props.dialogState.isLoadingRisks, isLoadingControls: this.props.dialogState.isLoadingControls, isSearchingCausalities: false, saveCausality: this.props.dialogState.saveCausality, search: this.props.dialogState.search, attachCausality: this.props.dialogState.attachCausality, closeDialog: this.props.dialogState.closeDialog, openDialog: this.props.dialogState.openDialog, afterSaveCallback: this.refetchTable.bind(this), comments: this.props.dialogState.comments, udfTypes: this.props.dialogState.udfTypes, udfSectionHeader: this.props.dialogState.udfSectionHeader, refreshAfterClose: this.props.dialogState.refreshAfterClose }))));
    };
    CausalityTable = __decorate([
        mobx_react_1.observer
    ], CausalityTable);
    return CausalityTable;
}(React.Component));
exports.default = CausalityTable;
